import React, { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import Header from './Header';
import axios from 'axios';
import { environment } from '../environment/production';

function UserDashboard() {
  const navigate = useNavigate();
  const [apiCall, setApiCall] = useState(0);
  const [picUpload, setPicUpload] = useState({
    image: '',
    imagePath: ''
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null); // For local preview before upload

  const options = {
    headers: {
      'Authorization': sessionStorage.getItem("access_token")
    }
  };

  function previewForm() {
    navigate('/preview');
  }

  const handlePhotoUpload = () => {
    if (!selectedFile) {
      alert("Please select a file first");
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(selectedFile);
    reader.onload = () => {
      const base64Image = reader.result;
      const arr = selectedFile.name.split(".");
      const ext = arr[arr.length - 1].toLowerCase();

      if (ext === "jpg" || ext === "jpeg") {
        axios.post(
          environment.apiUrl + "/Personal/DocUpload",
          JSON.stringify({
            user_id: sessionStorage.getItem("user_id"),
            image: base64Image
          }),
          { headers: options.headers }
        )
          .then((resp) => {
            alert(resp.data.msg);
            if (resp.data.fileName) {
              // update uploaded path + refresh preview with server image
              setPicUpload({ imagePath: resp.data.fileName });
              setPreviewUrl(environment.apiUrl + "/uploads/profile/" + resp.data.fileName);
            }
          })
          .catch((err) => {
            console.error("Upload failed:", err);
            alert("Failed to upload photo");
          });
      } else {
        alert("Only JPG or JPEG is allowed");
      }
    };
  };

  useEffect(() => {
    if (apiCall === 0) {
      if (sessionStorage.getItem("user_id") == null) {
        sessionStorage.clear();
        navigate("/");
      }
    }
    setApiCall(1);
  }, [apiCall, navigate]);

  return (
    <>
      <Header />
      <div className="main">
        <div className="container">
          <br /><br />
          <div className="middle">
            <h5>
              <span className="text-danger"><b>Note:-</b></span>
              Your application has been submitted, To preview form click on Preview Button.
              For further information please contact{" "}
              <a href="mailto:support.gstat@gstn.org.in">support.gstat@gstn.org.in</a>
            </h5>
            <br />

            <div className="form-group col-sm-4">
              <label>Upload Photo <span className="text-danger">*</span></label>
              <div className="input-group" style={{ gap: '1%' }}>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => {
                    setSelectedFile(e.target.files[0]);
                    setPreviewUrl(URL.createObjectURL(e.target.files[0])); // local preview
                  }}
                  name="image"
                  id="image"
                />
                <button
                  type="button"
                  className="btn btn-danger"
                  style={{ backgroundColor: '#212121' }}
                  onClick={handlePhotoUpload}
                >
                  Upload
                </button>
              </div>

              {/* Show uploaded photo preview */}
              {previewUrl && (
                <div style={{ marginTop: "10px" }}>
                  <img
                    src={previewUrl}
                    alt="Uploaded Preview"
                    style={{ width: "120px", height: "120px", borderRadius: "5px", objectFit: "cover", border: "1px solid #ddd" }}
                  />
                </div>
              )}
            </div>
          </div>

          <button className="btn btn-dark" onClick={previewForm}>Preview</button>
        </div>

        <div className="footer">
          <p className="text-center"><b>Designed and developed by GSTN</b></p>
        </div>
      </div>
    </>
  )
}

export default UserDashboard;
